import { useAuthStore } from "../stores/useAuthStore";
import { useFirebaseStore } from "../stores/useFirebaseStore";
import {
  handleLoginExpiration,
  handleLogout as handleLogoutExt,
  initiateGoogleLogin,
} from "../service/login";
import { useEffect } from "react";
import { showToast } from "../components/common/Toast";

export const useLogin = () => {
  const { setUser } = useAuthStore();
  const { fetchFavoriteMovies, fetchWatchListMovies, clearFirebaseStore } =
    useFirebaseStore();

  useEffect(() => {
    handleLoginExpiration(setUser);
  }, [setUser]);

  const handleLogin = async () => {
    try {
      const user = await initiateGoogleLogin();
      setUser(user);
      const isLoggedIn = Object.keys(user).length > 0;
      if (isLoggedIn) {
        fetchFavoriteMovies();
        fetchWatchListMovies();
        showToast(`Welcome back, ${(user as any).displayName || "User"}!`, "success");
      } else {
        showToast("Login cancelled or failed", "warning");
      }
    } catch (err) {
      console.error("Login error", err);
      showToast("Failed to login", "error");
    }
  };

  const logout = () => {
    try {
      handleLogoutExt();
      setUser({});
      clearFirebaseStore();
      showToast("Logged out successfully", "info");
    } catch (err) {
      console.error("Logout error", err);
      showToast("Error during logout", "error");
    }
  };

  return {
    handleLogin,
    logout,
  };
};
